import React from 'react'
import { Paragraph } from '@scentregroup/ui'

import { CONFIG_KEYS, getClientConfigBool } from '../../helpers/config-helper'

interface NotificationProps {
  className?: string
  message?: string
}

const EventNotification: React.FunctionComponent<NotificationProps> = ({
  className,
  message = '*Upcoming events are subject to change',
}) => {
  if (getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY)) {
    return (
      <Paragraph type="large" className={className}>
        {message}
      </Paragraph>
    )
  }

  return null
}

export default EventNotification
